type KeyValueType = {
  userId: string
  IsAudioUpload: boolean
  IsUseNsips: boolean
  hideCopyDonePatients: boolean
  lastAccessedRequestId: string
  portalSidebarCollapsed: boolean
  sessionPharmacistId: string
  filterPharmacistId: string
}

type KeyType = keyof KeyValueType

export const localStorageWrapper = {
  setItem: <T extends KeyType>(key: T, item: KeyValueType[T]): void => {
    localStorage.setItem(key, JSON.stringify(item))
  },
  getItem: <T extends KeyType>(key: T): KeyValueType[T] => {
    const itemStr = localStorage.getItem(key)
    return itemStr === null ? null : JSON.parse(itemStr)
  },
}

// ユーザー境界 (login/logout) で必ず消すキー。
// yakureki_data / yakureki_last_updated は delta 同期の永続キャッシュで、
// 残すと次のユーザーの差分取得に前ユーザーの薬歴がマージされて表示される。
// 表示設定 (portalSidebarCollapsed 等) はユーザーデータではないため残す
const USER_SCOPED_KEYS = [
  'yakureki_data',
  'yakureki_last_updated',
  'userId',
  'IsAudioUpload',
  'IsUseNsips',
  'lastAccessedRequestId',
  'sessionPharmacistId',
  'filterPharmacistId',
]

export const clearUserScopedStorage = (): void => {
  USER_SCOPED_KEYS.forEach((key) => localStorage.removeItem(key))
}
